<template>
    <div>
        <a href="https://www.techempower.com/benchmarks/" target="_blank">Web Framework Benchmarks</a> report generated
        by build
        <a
                :href="'http://ci.dragonwell-jdk.io/job/test.perf.dragonwell.FrameWorkBenchmark/' + result.buildNumber"
                target="_blank"
        >{{result.buildNumber}}</a>
        <v-row>
            <v-col cols="12">
                <v-select
                        dense
                        v-model="selectedBenchmark"
                        :items="['fortune', 'json', 'db', 'plaintext','query', 'update']"
                        @change="showSelected"
                ></v-select>
            </v-col>
        </v-row>

        <line-chart :chart-data="tableData" :options="options"></line-chart>
    </div>
</template>
<script>
    import LineChart from "./LineChart.js";
    import axios from "axios";

    export default {
        components: {
            LineChart
        },
        data() {
            return {
                selectedBenchmark: 'fortune',
                selectedMetric: 'tps',
                result: {},
                tableData: {labels: [], datasets: []},
                options: {
                    scales: {
                        yAxes: [
                            {
                                ticks: {
                                    beginAtZero: true
                                },
                                scaleLabel: {
                                    display: true,
                                    labelString: "tps/rt"
                                }
                            }
                        ],
                        xAxes: [
                            {
                                scaleLabel: {
                                    display: true,
                                    labelString: "ConcurrentLevel"
                                }
                            }
                        ]
                    }
                }
            };
        },
        mounted() {
            this.fillData();
        },
        methods: {
            showSelected() {
                let benchmark = this.result.benchmarks[this.selectedBenchmark];
                this.tableData = {
                    labels: benchmark.xaxis,
                    datasets: [
                        {
                            label: "OpenJDK",
                            backgroundColor: "#3789bd",
                            data: benchmark.sdk2metrics.openjdk[this.selectedMetric].map(n => n.toFixed(2))
                        },
                        {
                            label: "Dragonwell+Wisp2",
                            backgroundColor: "#f87979",
                            data: benchmark.sdk2metrics.ajdk_wisp[this.selectedMetric].map(n => n.toFixed(2))
                        }
                    ]
                };
            },
            fillData() {
                axios.get("/latestResults.json").then(response => {
                    this.result = response.data;
                    this.showSelected();
                });
            },
            getRandomInt() {
                return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
            }
        }
    };
</script>